import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
import { SortParameter } from '../../types';

export const trackSortingEvent = (sortParameter: SortParameter, previousPage: number) => {
    trackEvent({ review_ReviewAction: ['sort'], review_ReviewPage: [`${previousPage}`], review_SortReview: [sortParameter] });
};
